export enum Environment {
  localhost = 'development',
  int05 = 'int05',
  int02 = 'int02',
  test01 = 'test01',
  stage = 'stage',
  www = 'prod',
  'brighttalk.com' = 'prod'
}

export interface EnvironmentObject {
  /** The unqualified domain */
  domain: string
  /** The current environment */
  env: Environment
  /** An HTTPS qualified domain */
  publicServices: string
}

/** Returns information about the environment that the script is being run on */
function getEnvironment (devAsInt = false, host?: string): EnvironmentObject {

  // window is undefined in nextjs
  if (typeof window === 'undefined') {

    return {
      domain: 'int05.brighttalk.net',
      env: Environment.localhost,
      publicServices: devAsInt ? 'https://www.int05.brighttalk.net' : ''
    }
  }

  host = window.location.hostname

  if (host.match(/localhost/) !== null) {

    return {
      domain: devAsInt ? 'int05.brighttalk.net' : host,
      env: Environment.localhost,
      publicServices: devAsInt ? 'https://www.int05.brighttalk.net' : ''
    }

  }

  /** Replace talks-fe with www if we're on the watch screen */
  const safeHost = host.replace('talks-fe', 'www')

  const rgx = new RegExp(/^.*?(([^.]+)?\.?brighttalk\.(?:net|com))$/)
  const match = safeHost.match(rgx)
  if (match) {

    const [, rawDomain, env] = match
    const domain = rawDomain.replace('www.', '')

    return {
      domain,
      env: Environment[env || 'www'],
      publicServices: `https://www.${domain}`
    }

  }

  return {
    domain: '',
    env: Environment.localhost,
    publicServices: ''
  }

}

export default getEnvironment
